export const chapter = {
	PAGE_THEME_ENABLED: false,
};
